module.exports = require("./lo-LA.js");